import { render, staticRenderFns } from "./BetslipBet.vue?vue&type=template&id=0a0d5e3f&scoped=true"
import script from "./BetslipBet.vue?vue&type=script&lang=js"
export * from "./BetslipBet.vue?vue&type=script&lang=js"
import style0 from "./BetslipBet.vue?vue&type=style&index=0&id=0a0d5e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d5e3f",
  null
  
)

export default component.exports